import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BookingFilterDto, BookingResponseDto, BookingDetailDto } from '@opb-workspace/shared';

@Injectable({
  providedIn: 'root'
})
export class BookingsService {
  private apiUrl = `${environment.apiUrl}/v1/bookings`;

  constructor(private http: HttpClient) { }

  search(filters: BookingFilterDto): Observable<BookingResponseDto> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      const value = filters[key as keyof BookingFilterDto];
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => {
            params = params.append(key, item);
          });
        } else {
          params = params.set(key, value.toString());
        }
      }
    });

    return this.http.get<BookingResponseDto>(this.apiUrl, { params });
  }

  getDetail(id: number): Observable<BookingDetailDto> {
    return this.http.get<BookingDetailDto>(`${this.apiUrl}/${id}`);
  }

  getFilters(): Observable<{
    polPorts: any[];
    podPorts: any[];
    statuses: any[];
    clients: any[];
    exporters: any[];
    carriers: any[];
    vessels: any[];
    seasons: any[];
  }> {
    return this.http.get<any>(`${this.apiUrl}/filters`);
  }



  getExportData(filters: BookingFilterDto): Observable<any[]> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      const value = filters[key as keyof BookingFilterDto];
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => {
            params = params.append(key, item);
          });
        } else {
          params = params.set(key, value.toString());
        }
      }
    });

    return this.http.get<any[]>(`${this.apiUrl}/export-data`, { params });
  }

  downloadPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, {
      responseType: 'blob'
    });
  }
}


